import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "vue-select/dist/vue-select.css";

// plugins
import './plugins/vee-validate'
import './plugins/vue-meta'
import './plugins/boostrap-vue'
import datePlugin from './plugins/date.plugin'
import 'bootstrap/dist/js/bootstrap.js';

// core
import './core/vue/error-handler'

// mixins
import { userMixin } from '@/modules/user/mixins/user.mixin'
import '@/mixins/vue-alerts'
import {
    date,
    phone,
    studentSie,
    price,
    currency,
    ssn,
    capitalize,
    daywithnumber,
    formatDateWithHour,
    formatDateAsDay,
    hourFilter,
    emptyFilter,
    upperCaseFilter,
  } from './filters/filters';
Vue.mixin(userMixin)

import {commonMixin} from '@/mixins/common.mixin'
Vue.mixin(commonMixin)


//plugin
Vue.use(datePlugin)
//filters
Vue.filter('phone', phone);
Vue.filter('studentSie', studentSie);
Vue.filter('price', price);
Vue.filter('currency', currency);
Vue.filter('date', date);
Vue.filter('ssn', ssn);
Vue.filter('capitalize', capitalize);
Vue.filter('daywithnumber', daywithnumber);
Vue.filter('formatDateWithHour', formatDateWithHour);
Vue.filter('formatDateAsDay', formatDateAsDay);
Vue.filter('hour', hourFilter);
Vue.filter('empty', emptyFilter);
Vue.filter('uppercase', upperCaseFilter);
// styles
import './sass/style.scss'

import vSelect from 'vue-select'

import '@fortawesome/fontawesome-free/css/all.min.css';

Vue.component('v-select', vSelect)


Vue.config.productionTip = false

new Vue({
    router,
    store,
    mounted() {
      if (this.isTrainingEnv()) {
        const favicon = document.getElementById('favicon');
        favicon.href = '/favicon-training.ico';
      }
    },
    render: (h) => h(App)
}).$mount('#app')
